import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "react-oidc-context";
import cx from "classnames";
import collabDocApi from "../../api/forms/collabDocApi";
import TinyLoader from "../loaders/TinyLoader";

interface CollabDocDownloadPdfButtonProps {
  answerSetUniqueId: string;
  answerSetTitle: string;
}

const CollabDocDownloadPdfButton = ({
  answerSetUniqueId,
  answerSetTitle,
}: CollabDocDownloadPdfButtonProps) => {
  // Auth/API
  const auth = useAuth();
  const apiCollabDocs = new collabDocApi(auth.user?.access_token);

  // State
  const [isCallingApi, setIsCallingApi] = useState<boolean>(false);

  const handleClick = () => {
    setIsCallingApi(true);
    apiCollabDocs.downloadPdf(
      answerSetUniqueId,
      answerSetTitle,
      onSuccess,
      onError
    );
  };

  const onSuccess = () => {
    setIsCallingApi(false);
  };

  const onError = (error: any) => {
    setIsCallingApi(false);
    console.log("Error downloading PDF", error);
  };

  return (
    <div className="hidden md:block mb-1 text-right">
      <button
        onClick={handleClick}
        className={cx(" text-white px-2 py-1 text-sm hover:underline ", {
          "hover:cursor-wait": isCallingApi,
          "hover:cursor-pointer": !isCallingApi,
        })}
        disabled={isCallingApi}
      >
        <TinyLoader
          colour={"ffffff"}
          classNames="mr-1"
          isLoading={isCallingApi}
        />
        <FontAwesomeIcon icon={faFileDownload} size="xs" className="mr-1" />
        Download
      </button>
    </div>
  );
};

export default CollabDocDownloadPdfButton;
